import ApiClient from "./Api/ApiClient";
import GoalService from "./GoalService";

class MessageService {
    constructor() {
        this.uri = 'message';
        this.apiClient = new ApiClient();
    }

    async getClients({page = 1, search = ''}) {
        try {

            return await this.apiClient.doRequest({
                method: ApiClient.GET,
                uri: `message/clients?page=${page}&per_page=20&search=${search}`,
                expectedStatus: 200,
            });

        } catch (e) {
            throw e;
        }
    }

    async createMessage(object) {
        try {

            return await this.apiClient.doRequest({
                method: ApiClient.POST,
                uri: 'message',
                expectedStatus: 201,
                body: object,
            });

        } catch (e) {
            throw e;
        }
    }

    async getHistoryAdmin({page = 1, search = ''}) {
        try {

            return await this.apiClient.doRequest({
                method: ApiClient.GET,
                uri: `message/by-company?page=${page}&per_page=20&search=${search}`,
                expectedStatus: 200,
            });

        } catch (e) {
            throw e;
        }
    }

    async getDetails(uuid) {
        try {

            return await this.apiClient.doRequest({
                method: ApiClient.GET,
                uri: `message/${uuid}`,
                expectedStatus: 200,
            });

        } catch (e) {
            throw e;
        }
    }

}

export default MessageService;